export default __webpack_public_path__ + "static/media/Premier_Membership_Icon.ed77bce8.svg";